import devConfig from './dev';
import preview1Config from './preview1';
import preview2Config from './preview2';
import preview3Config from './preview3';
import preview4Config from './preview4';
import prodConfig from './production';
import stagingConfig from './staging';
export interface Config {
  env: 'dev' | 'staging' | 'production' | 'preview1' | 'preview2' | 'preview3' | 'preview4';
  apiServerBase: string;
  tileServerBase: string;
  mapboxToken: any;
  geotechStudyCost: number;
  googleMapsApiToken: string;
  esriToken: string;
  posthogApiKey: string;
  posthogApiHost: string;
  posthogUiHost: string;
  personaEnvironmentId: string;
  knockWebChannelId: string;
  knockPublicKey: string;
  bugsnagApiKey: string;
  /** Preview slot a staging build serves (`new-preview1`, later `preview1`); unset on staging itself. */
  previewEnv?: string;
}

const env = import.meta.env.MODE;

export default function getConfig() {
  if (env === 'production') {
    return prodConfig;
  } else if (env === 'staging') {
    return stagingConfig;
  } else if (env === 'preview1') {
    return preview1Config;
  } else if (env === 'preview2') {
    return preview2Config;
  } else if (env === 'preview3') {
    return preview3Config;
  } else if (env === 'preview4') {
    return preview4Config;
  }
  return devConfig;
}
